import { useContext } from 'react';
import { ThemeContext } from './ThemeProvider';
export function useTheme() {
    const ctx = useContext(ThemeContext);
    if (!ctx)
        throw new Error('useTheme requiere <ThemeProvider />');
    return ctx;
}
